import api from "./api";

const CHUNK = 5 * 1024 * 1024; // 5MB

// Chunked upload to bypass proxy body limits (supports large video/audio).
export async function uploadFile(file, meta, onProgress) {
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  const init = await api.post("/admin/files/upload-init", {
    filename: file.name,
    content_type: file.type || "application/octet-stream",
    total_chunks: total,
    ...meta,
  });
  const uploadId = init.data.upload_id;

  for (let i = 0; i < total; i++) {
    const buf = await file.slice(i * CHUNK, (i + 1) * CHUNK).arrayBuffer();
    await api.post(`/admin/files/upload-chunk/${uploadId}?index=${i}`, buf, {
      headers: { "Content-Type": "application/octet-stream" },
    });
    if (onProgress) onProgress(Math.round(((i + 1) / total) * 100));
  }

  const done = await api.post(`/admin/files/upload-complete/${uploadId}`);
  return done.data;
}
